import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import React from "react";
import { DocumentCorrectionRequestButton } from "./components/DocumentCorrectionRequestButton";
import { DocumentSignButton } from "./components/DocumentSignButton";
import { ParamsWatcher } from "./components/ParamsWatcher";
import { SectionDescriptionDetail } from "./components/SectionDescriptionDetail";
import { SegmentsSection } from "./components/SegmentsSection";
import { selectDocument } from "../../store/documentSignerShow/selectors/selectDocument";
import { useSelector } from "react-redux";
import { selectUser } from "../../store/userAuthentication/selectors/selectUser";

export const SignerDocumentDetail: React.FC = () => {
  const document = useSelector(selectDocument);
  const userLoggedIn = useSelector(selectUser);

  let isUserAllowedToViewDocument = [];

  if (document.stakeholdersDnis != undefined) {
    isUserAllowedToViewDocument = document.stakeholdersDnis!.filter(
      (dni: any) => dni === userLoggedIn?.dni?.split(".").join("")
    );
  }
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Acuerdos" : ""}
              defaultHref="/app/acuerdos/firma"
              color="light"
            />
          </IonButtons>
          <IonTitle>Acuerdo</IonTitle>
          <IonButtons slot="end">
            <DocumentCorrectionRequestButton />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className={isPlatform("desktop") ? "ion-padding" : ""}>
        <ParamsWatcher />
        {document.stakeholdersDnis === undefined && (
          <IonText>
            <p>Cargando...</p>
          </IonText>
        )}
        {document.stakeholdersDnis != undefined && (
          <>
            {(isUserAllowedToViewDocument?.length === 0 && document.status?.name != "Anulado") ? (
              <IonText>
                <p>No tiene acceso al acuerdo</p>
              </IonText>
            ) : null}
            {(isUserAllowedToViewDocument?.length > 0 && document.status?.name === "Anulado")  ? (
              <IonText>
                <p>Este documento fué anulado</p>
              </IonText>
            ) : null}

            {(isUserAllowedToViewDocument?.length > 0 &&
              document.status?.name != "Anulado") ? (
              <>
                <SectionDescriptionDetail />
                <SegmentsSection />
                <DocumentSignButton />
              </>
            ) : null}
          </>
        )}
      </IonContent>
    </IonPage>
  );
};
